import type { TranslationStep } from '../api/client';

// Mirror of the server-side translateForOr in workers/billing-api/src/index.ts.
// Computed client-side so the admin sees the preview ("Will write X to Y") in
// the picker BEFORE clicking commit. The server runs this again at commit
// time and is the source of truth — these two functions must stay in sync.
export function translateForOr(
  values: Record<string, number | null | undefined>,
  asset_type: string,
): { translated: Record<string, number>; steps: TranslationStep[] } {
  const out: Record<string, number> = {};
  const steps: TranslationStep[] = [];

  function setStep(srcKey: string, srcVal: number, tgtKey: string, tgtVal: number, unitNote?: string) {
    out[tgtKey] = tgtVal;
    steps.push({
      source_key: srcKey,
      source_value: srcVal,
      target_key: tgtKey,
      target_value: tgtVal,
      unit_note: unitNote,
    });
  }

  for (const [k, v] of Object.entries(values)) {
    if (v === null || v === undefined || !Number.isFinite(v)) continue;
    const num = v as number;

    if (k === 'cumulative') {
      if (asset_type === 'ElectricityConsumerAsset') {
        setStep(k, num, 'Import_kWh', num);
      } else if (asset_type === 'GroundwaterSensorAsset') {
        const liters = Math.round(num * 1000);
        setStep(k, num, 'waterLevel', liters, `${num} m³ × 1000 → ${liters} L`);
      } else {
        out[k] = num;
      }
      continue;
    }

    if (k === 'waterVolume_m3') {
      const liters = Math.round(num * 1000);
      setStep(k, num, 'waterLevel', liters, `${num} m³ × 1000 → ${liters} L`);
      continue;
    }
    if (k === 'waterLevel' && asset_type === 'GroundwaterSensorAsset') {
      const liters = Math.round(num);
      if (liters !== num) {
        setStep(k, num, 'waterLevel', liters, 'rounded to integer liters');
      } else {
        setStep(k, num, 'waterLevel', liters);
      }
      continue;
    }

    out[k] = num;
  }

  return { translated: out, steps };
}
